module.exports = __webpack_public_path__ + "img/img36.f48070e1.jpg";